import { Roles } from '@/router/roles';

export const sharedRoutes = [
	{
		path: 'locations',
		name: 'Locations',
		meta: [Roles.REFADMIN, Roles.ASSIGNOR],
		component: () => import('@/views/EvergreenSports/Locations/Locations.vue')
	},
	{
		path: 'upload/:uploadType?',
		name: 'bulk-upload',
		meta: [Roles.REFADMIN, Roles.ASSIGNOR],
		component: () => import('@/views/BulkUpload/BulkUploadPage.vue')
	},
	{
		path: 'broadcasts/group/:groupNumber',
		name: 'Broadcasts',
		meta: [Roles.REFADMIN, Roles.ASSIGNOR],
		component: () => import('@/views/RefereeAdmin/ViewSiteMail/SiteBroadcastPage.vue')
	}
];
